import * as React from 'react';
import ConversationTimeline from '../../../components/Contact/Conversation/ConversationTimeline/ConversationTimeline';
import { ContactDisplayLayout } from '../../../sic-lib/enums/ContactDisplayLayout';
import { Contact } from '../../../sic-lib/types/Contact';
import MainHeader from '../MainHeader/MainHeader';

interface Props {
    contact: Contact;
    hasMediumScreen: boolean;
    cdDispatch: React.Dispatch<{ view: ContactDisplayLayout }>;
}

export default function ContactMain({ contact, hasMediumScreen, cdDispatch }: Props) {
    return (
        <div className="contactDisplay__main">
            <div className="cdMain__header">
                <MainHeader
                    contact={contact}
                    cdDispatch={cdDispatch}
                    hasMediumScreen={hasMediumScreen}
                />
            </div>
            <div className="cdMain__messaging">
                <div className="cdMain__timeline">
                    <ConversationTimeline contact={contact} />
                </div>
            </div>
        </div>
    );
}
